import { configureStore } from '@reduxjs/toolkit';
import articlesReducer from '../features/CreateBrief/slice';
import tweetsReducer from '../features/GetTweets/slice';

export const store = configureStore({
    reducer: {
        articles: articlesReducer,
        tweets: tweetsReducer,
    }
});

// Selectors
export const selectSearchParams = state => state.articles.searchParams;
export const selectArticles = state => state.articles.articles;

export const selectDontShowAgainSetBriefLanguage = state => state.articles.dontShowAgainSetBriefLanguage;
export const selectUserSelectedBriefLanguage = state => state.articles.userSelectedBriefLanguage;
export const selectClaims = state => state.articles.claims;
export const selectStory = state => state.articles.story;

export const selectSelectedStoryIndex = state => state.articles.selectedStoryIndex;
export const selectLoading = state => state.articles.loading;
export const selectPristine = state => state.articles.pristine;

export const selectPublisherMap = state => state.articles.publisherMap;
export const selectSelectedArticles = state => state.articles.selectedArticles;
export const selectSelectedArticlesArray = state => state.articles.selectedArticlesArray;

export const selectSelectedClaimsArray = state => state.articles.selectedClaimsArray;

export const selectLastSelectedClaims = state => state.articles.lastSelectedClaims;

export const selectLastSelectedArticles = state => state.articles.lastSelectedArticles;

export const selectSelectedStoriesArray = state => state.articles.selectedStoriesArray;

// Funnel / routing selectors
export const selectActiveTab = state => state.articles.activeTab;
export const selectCurrentStep = state => state.articles.currentStep;
export const selectStories = state => state.articles.stories;
export const selectStoryLocal = state => state.articles.storyLocal;
export const selectErrorStories = state => state.articles.errorStories;
export const selectLoadingArticles = state => state.articles.loadingArticles;
export const selectHasMoreStories = state => state.articles.hasMoreStories;
export const selectIsLoadingMoreStories = state => state.articles.isLoadingMoreStories;
export const selectTotalStories = state => state.articles.totalStories;
export const selectNavigateBack = state => state.articles.navigateBack;

export const selectSelectedTweets = state => state.tweets.selectedTweets;

export const selectUrlsFromTweetsAndArticles = state => {
    return [
        ...state.articles.selectedArticlesArray.map((a) => a.url),
        ...state.tweets.selectedTweets.map((id) => 'https://twitter.com/twitter/status/' + id)
    ];
};
